import React from 'react';
import wave from '../../assets/contact/wave.png'
import './style.css';

function Contact() {
    return (
        <div id='contact'>
            <section className='Contact'>
                <h2 id='title'>Contact me</h2>
                <p id='text1'>Interested in freelance projects, contact me to make a budget.</p>
                <p id='text2'>I currently live in Brazil in the state of  São Paulo - SP:</p>
                <div id='contacts'>
                    <button><button className='i'><i class="fa fa-whatsapp" aria-hidden="true" /></button>&nbsp; + 55 11 9 8470 8101</button>
                    <button><button className='i'><i class="fa fa-envelope-o" aria-hidden="true" /></button>&nbsp; rafaeloduarte@gmail.com</button>
                </div>
                <div id='waves'>
                    <div
                        className='wave wave1'
                        style={{ backgroundImage: `url(${wave})` }}
                    />
                    <div className='wave wave2' style={{ backgroundImage: `url(${wave})` }} />
                    <div className='wave wave3' style={{ backgroundImage: `url(${wave})` }} />
                    <div className='wave wave4' style={{ backgroundImage: `url(${wave})` }} />
                </div>
            </section>
        </div>
    );
}

export default Contact;